import {
  ListProps,
  TextInput,
  DateInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  NullableBooleanInput,
  AutocompleteInput,
  AutocompleteArrayInput,
  BulkDeleteButton,
} from "react-admin";
import { CustomList } from "../../components/CustomList";
import { useOptionsResource } from "../../shared/hooks/useOptionsResource";
import { initField, getDefaultListProps } from "../../shared/utils";
import { DriverSummaryPdfBulkButton } from "./DriverSummaryPdfBulkButton";
import { RouteDatagrid } from "./RouteDatagrid";
import { SendTrackMeButtonsButton } from "./SendTrackMeButton";
import { UpdateRouteStatusButton } from "./UpdateRouteStatusButton";
import { ForceUpdateRouteStatusButton } from "./ForceUpdateRouteStatusButton";
import { HideOnMapsButton, ShowOnMapsButton } from "./ShowHideOnMapsButtons";
import { PrintMultiRouteZipButton } from "./PrintMultiRouteZipButton";
import { BlockPrintMultiRouteZipButton } from "./BlockPrintMultiRouteZipButton";
import { getUser } from "../../authProvider";
import {ReferenceArrayInputSubject} from "../../components/reference-inputs/ReferenceArrayInputSubject";

export const RouteList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");
  const filters = options
    ? [
      <TextInput alwaysOn {...initField("id", options)} />,
      <DateInput {...initField("planned_date_after", options)} label="Pianificata dal" />,
      <DateInput {...initField("planned_date_before", options)} label="Pianificata al" />,
      <DateInput {...initField("planned_date__date", options)} label="Pianificata il" />,
      <SelectInput
        choices={options.status.choices}
        {...initField("status", options, "array")}
        alwaysOn
      />,
      <ReferenceInput
        {...initField("driver", options)}
        reference="autocomplete/employee"
        alwaysOn
      >
        <AutocompleteInput optionText="label" />
      </ReferenceInput>,
      <ReferenceInput
        {...initField("carrier", options)}
        filter={{ type: "carrier" }}
        reference="autocomplete/subject"
        alwaysOn
      >
        <AutocompleteInput optionText="label" />
      </ReferenceInput>,
      <ReferenceInput
        {...initField("vehicle", options)}
        reference="autocomplete/vehicle"
        alwaysOn
      >
        <AutocompleteInput optionText="label" />
      </ReferenceInput>,
      <NullableBooleanInput {...initField("sent", options)} />,
      <NullableBooleanInput {...initField("show_on_maps", options)} />,
      <NullableBooleanInput {...initField("printed", options)} label="Stampato?" alwaysOn />,
      <ReferenceArrayInput
        {...initField("tags_filter", options)}
        label="Tag"
        reference="autocomplete/tag"
        alwaysOn
      >
        <AutocompleteArrayInput optionText="label" />
      </ReferenceArrayInput>,
      <NullableBooleanInput {...initField("has_file", options)} label="Borderaux firmato" />,
      <ReferenceArrayInputSubject
          {...initField("start_points", options)}
          label="Magazzino competenza"
          className="filter-field-small"
          filter={{ type: "default_store" }}
          alwaysOn
      />
    ]
    : [];
  return options ? (
    <CustomList
      sort={{ field: "id", order: "DESC" }}
      filters={filters}
      {...getDefaultListProps(props)}
      bulkActionButtons={
        <>
          <SendTrackMeButtonsButton />
          <ShowOnMapsButton />
          <HideOnMapsButton />
          <BulkDeleteButton undoable />
          <DriverSummaryPdfBulkButton />
          <UpdateRouteStatusButton />
          <ForceUpdateRouteStatusButton />
          {getUser()?.is_admin ? <PrintMultiRouteZipButton /> : null}
          {getUser()?.is_admin ?<BlockPrintMultiRouteZipButton /> : null}
        </>
      }
    >
      <RouteDatagrid options={options} />
    </CustomList>
  ) : null;
};
